import { render, staticRenderFns } from "./reservation-form.vue?vue&type=template&id=458808bd&scoped=true&"
import script from "./reservation-form.ts?vue&type=script&lang=ts&"
export * from "./reservation-form.ts?vue&type=script&lang=ts&"
import style0 from "./reservation-form.scss?vue&type=style&index=0&id=458808bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458808bd",
  null
  
)

export default component.exports